import axiosServices from "../utils/axios"

interface FetchApiResponce{
    data: any[]
}
export const fetchVesselList = async()=>{
    const responce = await axiosServices.get<FetchApiResponce>('/vessel')
    return responce.data;
}

export const filterVessel = (vesselList: any[], vessel_id: string) =>{
 const data =   vesselList.filter(vessel => vessel.vessel_id === vessel_id);
 return data;
};

export const updateVesselData = async (
    vessel_id: string,
  data: {
    [key: string]: any;
    vessel_id: string;
  }
) => {
   await axiosServices.put(`/vessel/${vessel_id}`, data);
  return {
    success: true,
    data
  }
};

export const deleteVesselData = async (id: string) => {
  const response = await axiosServices.delete<any>(`/vessel/${id}`, {data:{vessel_id:id}});
  return response.data;
}

export const addVesselData = async (
  data: {
    [key: string]: any;
  }
) => {
  const response = await axiosServices.post(`/vessel`, data);
  return response.data.data;
};